module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAABJklEQVQ4jb3UK0hEQRTG8d+uDwTRbtAgCvaVjYJYbMImDSZf1WIxWLZYxTX46AZBEItaBZtFjbJBFEwGBTH4YmCE8aK7KyyeMnPO/fjPN8w9J1coFNSJIUxgHc+1pK3oQQXdeMcm9hPNMqZRxV5Sn8Fk3L+iHGCjKCWi+wysJa5tGSNTGEvyaj5JjjCMhXr3jlGK+krMcynsAed4aRD2GPV3X4V8bf3f4t9hZ7jFRTNgG+jFVTNgffGfam8GbAU7GK8nbG0AtopLnPwFNoD5JP/AMa6xFmuhT0cyjGIKe0uKxYzwCUvYwlyEdvxi7DVMjS4sojPzcTDp2dDk/XG/i5uMNhjaDs7C6eVfTgujJ0yRAArtM5uZHN+i3gMc4DSOoMPo8OfAJ2NPNR41xpoJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/icon/icon_yjfk.png
// module id = frOR
// module chunks = 41